import { Component } from '@angular/core';
import { AuthService } from '../../services/auth.service';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-terms',
  standalone: true,
  imports: [],
  templateUrl: './terms.component.html',
  styleUrl: './terms.component.scss'
})
export class TermsComponent {
  constructor(readonly authService: AuthService) {}

  // The editor outputs space as &nbsp; and it causes line breaks to behave incorrectly
  tncContent = this.authService.termsContent().replace(/&nbsp;/g, ' ');

  async acceptTnc(): Promise<void> {
    await this.authService.acceptTermsAndConditions();
    await this.authService.refreshMe();
  }

  goBack(): void {
    window.location.href = environment.colab.axisUrl;
  }
}
